import { createFileRoute, Outlet, useNavigate } from "@tanstack/solid-router"
import type { ResourceConfig } from "cka-types"
import { onMount, Show } from "solid-js"
import { VisibilityProvider } from "~/components/providers/visibility"
import { observe } from "~/lib/nui"
import { orpc } from "~/lib/orpc"
import { isFiveMBrowser } from "~/lib/utils"

export const Route = createFileRoute("/_authenticated/tablet")({
  component: RouteComponent
})

function RouteComponent() {
  const navigate = useNavigate()

  onMount(async () => {
    if (isFiveMBrowser()) {
      observe<{ config: ResourceConfig; discordId: string; cid: number }>("setConfig", async (data) => {
        const res = await orpc.fivem.userAuth.call({
          orgId: data.config.orgId,
          discordId: data.discordId,
          cid: data.cid
        })

        console.log(res.message)

        navigate({
          to: "/tablet/$orgId",
          params: { orgId: data.config.orgId }
        })
      })
    }
  })

  return (
    <Show when={isFiveMBrowser()} fallback={<Outlet />}>
      <VisibilityProvider>
        <Outlet />
      </VisibilityProvider>
    </Show>
  )
}
